import React from "react";
import {
  FaLeaf,
  FaInfoCircle,
  FaStar,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

export default function RestaurantCardMobile() {
  return (
    <div className="d-block d-md-none p-3 border-bottom">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="text-success small fw-semibold d-flex align-items-center mb-1">
            <FaLeaf className="me-1" /> Pure Veg
          </div>
          <div className="d-flex align-items-center">
            <h5 className="mb-0 fw-bold me-1">Haldiram's</h5>
            <FaInfoCircle className="text-muted" size={14} />
          </div>
        </div>

        <div className="text-end">
          <div className="bg-success text-white px-2 py-1 rounded d-inline-flex align-items-center">
            <span className="fw-bold me-1">4.0</span>
            <FaStar size={12} />
          </div>
          <div className="text-muted small">11.8K ratings</div>
        </div>
      </div>

      {/* Location and Time */}
      <div className="mt-2">
        <div className="text-muted small d-flex align-items-center mb-1">
          <FaMapMarkerAlt className="me-1" />
          <span>1.6 km • Sector 15 ▾</span>
        </div>
        <div className="text-muted small d-flex align-items-center">
          <FaClock className="me-1" />
          <span>20–25 mins • Schedule for later ▾</span>
        </div>
      </div>
    </div>
  );
}
